var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmbedded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3589_8649)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#paint0_linear_3589_8649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 50,
    height: 50,
    rx: 9.8,
    fill: "url(#paint1_linear_3589_8649)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3589_8649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 14.25C18.6172 14.25 14.25 18.6172 14.25 24C14.25 29.3828 18.6172 33.75 24 33.75C24.8988 33.75 25.625 34.4762 25.625 35.375C25.625 36.2738 24.8988 37 24 37C16.8195 37 11 31.1805 11 24C11 16.8195 16.8195 11 24 11C31.1805 11 37 16.8195 37 24V25.625C37 28.3164 34.8164 30.5 32.125 30.5C30.6371 30.5 29.3016 29.8297 28.4078 28.7785C27.25 29.8449 25.7012 30.5 24 30.5C20.4098 30.5 17.5 27.5902 17.5 24C17.5 20.4098 20.4098 17.5 24 17.5C25.4168 17.5 26.727 17.952 27.7934 18.7238C28.0828 18.4699 28.4586 18.3125 28.875 18.3125C29.7738 18.3125 30.5 19.0387 30.5 19.9375V25.625C30.5 26.5238 31.2262 27.25 32.125 27.25C33.0238 27.25 33.75 26.5238 33.75 25.625V24C33.75 18.6172 29.3828 14.25 24 14.25ZM27.25 24C27.25 23.138 26.9076 22.3114 26.2981 21.7019C25.6886 21.0924 24.862 20.75 24 20.75C23.138 20.75 22.3114 21.0924 21.7019 21.7019C21.0924 22.3114 20.75 23.138 20.75 24C20.75 24.862 21.0924 25.6886 21.7019 26.2981C22.3114 26.9076 23.138 27.25 24 27.25C24.862 27.25 25.6886 26.9076 26.2981 26.2981C26.9076 25.6886 27.25 24.862 27.25 24Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3589_8649",
    x1: 25.5,
    y1: -0.00000629572,
    x2: 30.2016,
    y2: 47.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8358BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B1CF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3589_8649",
    x1: 25.5625,
    y1: -1.00001,
    x2: 30.46,
    y2: 48.5156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8358BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B1CF7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3589_8649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3589_8649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbedded);
export default __webpack_public_path__ + "static/media/embedded.46473ccca954fdd072d95fae53aff339.svg";
export { ForwardRef as ReactComponent };